import { Paper } from '@mui/material'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

export default function DataDirectorHeader(props) {
  return (
    <MDBox
      textAlign='left'
      py={2}
      px={3}
      sx={{
        bgcolor: '#29261f'
      }}
    >
      
      <MDTypography
        variant='h3'
        sx={{
          color: '#cf9e0b'
        }}
      >
        Data Director
      </MDTypography>
      
    </MDBox>
  )
}